import { lazyImportSvg } from '@/shared/utils/lazy/lazy-import-svg';

export const SnsIcons = {
  Instagram: lazyImportSvg(() => import('@/assets/icons/sns/instagram.svg')),
  BnA: lazyImportSvg(() => import('@/assets/icons/sns/bna.svg')),
  SearchInstagram: lazyImportSvg(() => import('@/assets/icons/sns/search-instagram.svg')),
  SearchInstagramSmall: lazyImportSvg(() => import('@/assets/icons/sns/search-instagram-sm.svg')),
  SearchInstagramDisabledSmall: lazyImportSvg(
    () => import('@/assets/icons/sns/search-instagram-disabled-sm.svg'),
  ),
  SearchInstagramReels: lazyImportSvg(
    () => import('@/assets/icons/sns/search-instagram-reels.svg'),
  ),
  SearchBnA: lazyImportSvg(() => import('@/assets/icons/sns/search-bna.svg')),
  SearchTiktok: lazyImportSvg(() => import('@/assets/icons/sns/search-tiktok.svg')),
  SearchTiktokSmall: lazyImportSvg(() => import('@/assets/icons/sns/search-tiktok-sm.svg')),
  SearchTiktokDisabledSmall: lazyImportSvg(
    () => import('@/assets/icons/sns/search-tiktok-disabled-sm.svg'),
  ),
  Tiktok: lazyImportSvg(() => import('@/assets/icons/sns/tiktok.svg')),
  Youtube: lazyImportSvg(() => import('@/assets/icons/sns/youtube.svg')),
  TiktokBlack: lazyImportSvg(() => import('@/assets/icons/sns/tiktok-black.svg')),
};

export default SnsIcons;
